import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { catchError, Observable, throwError } from 'rxjs';
import { AuthGuard } from './guards/auth.guard';

/**
 * Intercept
 *
 * @param req
 * @param next
 */
export const authInterceptor = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
       const router = inject(Router);

    let token = JSON.parse(localStorage.getItem("USER_TOKEN"));

    // Clone the request object
    let newReq = req.clone();

    // Request
    //
    // If the access token didn't expire, add the Authorization header.
    // We won't add the Authorization header if the access token expired.
    // This will force the server to return a "401 Unauthorized" response
    // for the protected API routes which our response interceptor will
    // catch and delete the access token from the local storage while logging
    // the user out from the app.
    if (token && token.token && !AuthUtils.isTokenExpired(token.token)) {
        newReq = req.clone({
            // headers: req.headers.set('user-login', token.userToken),
           // headers: req.headers.set('USER_TYPE', "DMS"),
        });
    }

    // Response
    return next(newReq).pipe(
        catchError((error) => {
            // Catch "401 Unauthorized" responses
            if (error instanceof HttpErrorResponse && error.status === 401&& error.message.includes('token')) {
                localStorage.removeItem('USER_TOKEN');
                router.navigate(["/apps/auth/login"]);

                    //  router.navigate(["/"], {
                    //     queryParams: { returnUrl: state.url },
                    //     queryParamsHandling: "merge",
                    // });
                // Reload the app
                //location.reload();
            }

            return throwError(error);
        }),
    );
};
